import Image from 'next/image';

import videoPlay from '@/assets/images/icons/video-play.svg';

export const HomeLearnVideo = (video: any) => {
  const { title, thumbNail, desc, videoSource } = video;
  return (
    <div className="item">
      <div className="video__card">
        <div className="video__media">
          {/* line no:7 autoPlay="autoplay" */}
          <video poster={thumbNail}>
            <source src={videoSource} type="video/mp4" />
          </video>
          <div className="video__control">
            <a href="#" className="play-button">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={videoPlay}
                alt="play button"
              />
            </a>
            <span className="time text--bold text--white">00:32</span>
          </div>
        </div>
        <div className="video__footer">
          <p className="text--black text--bold title">{title}</p>
          <p className="text--gray text--regular desc">{desc}</p>
        </div>
      </div>
    </div>
  );
};
